export default __webpack_public_path__ + "static/404~stOjQlBH-99a147febfdb9796be4d52319bce7b12.jpg";